import { PayloadAction, createSlice } from "@reduxjs/toolkit"
import { products } from "../../types/types";
import {
  getAllProductType,
  getAllProducts,
  getDiscountProducts,
  getPendingProducts,
  getSubCategories,
} from "../thunk";

interface ProductsState {
  products: products[];
  categories: any;
  discountProducts: products[];
  discountStatus: string;
  discountError: string;
  pendingProducts: any[];
  pendingPagination: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  } | null;
  pendingStatus: string;
  pendingError: string;
  subCategories: any[];
  subCategoriesStatus: string;
  subCategoriesError: string;
  status: string;
  error: string;
}

const initialState: ProductsState = {
  products: [],
  categories: [],
  discountProducts: [],
  discountStatus: "idle",
  discountError: "",
  pendingProducts: [],
  pendingPagination: null,
  pendingStatus: "idle",
  pendingError: "",
  subCategories: [],
  subCategoriesStatus: "idle",
  subCategoriesError: "",
  status: 'idle',
  error: ''
}

const productsSlice = createSlice({
  name: "products",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllProducts.pending, (state) => {
        state.status = 'loading'
        state.error = 'nil'
      })
      .addCase(getAllProducts.fulfilled, (state, action: PayloadAction<products[]>) => {
        state.status = "success"
        state.products = action.payload;
        state.error = 'nil'
      })
      .addCase(getAllProducts.rejected, (state, action) => {
        state.status = "failed"
        state.error = action.error?.message || "Unknown error"
      })

      .addCase(getAllProductType.pending, (state) => {
        state.status = 'loading'
        state.error = 'nil'
      })
      .addCase(getAllProductType.fulfilled, (state, action: PayloadAction<any>) => {
        state.status = "success"
        state.categories = action.payload;
        state.error = 'nil'
      })
      .addCase(getAllProductType.rejected, (state, action) => {
        state.status = "failed"
        state.error = action.error?.message || "Unknown error"
      })

      .addCase(getPendingProducts.pending, (state) => {
        state.pendingStatus = "loading";
        state.pendingError = "";
      })
      .addCase(getPendingProducts.fulfilled, (state, action: PayloadAction<any>) => {
        state.pendingStatus = "success";
        state.pendingProducts = Array.isArray(action.payload?.data)
          ? action.payload.data
          : [];
        state.pendingPagination = action.payload?.pagination || null;
        state.pendingError = "";
      })
      .addCase(getPendingProducts.rejected, (state, action: any) => {
        state.pendingStatus = "failed";
        state.pendingError =
          action.payload || action.error?.message || "Failed to fetch pending products";
      })

      .addCase(getDiscountProducts.pending, (state) => {
        state.discountStatus = "loading";
        state.discountError = "";
      })
      .addCase(getDiscountProducts.fulfilled, (state, action: PayloadAction<any>) => {
        state.discountStatus = "success";
        const payload = action.payload;
        state.discountProducts = Array.isArray(payload)
          ? payload
          : Array.isArray(payload?.data)
            ? payload.data
            : [];
        state.discountError = "";
      })
      .addCase(getDiscountProducts.rejected, (state, action: any) => {
        state.discountStatus = "failed";
        state.discountError =
          action.payload || action.error?.message || "Failed to fetch discount products";
      })

      // Subcategories
      .addCase(getSubCategories.pending, (state) => {
        state.subCategoriesStatus = "loading";
        state.subCategoriesError = "";
      })
      .addCase(getSubCategories.fulfilled, (state, action: PayloadAction<any>) => {
        state.subCategoriesStatus = "success";
        state.subCategories = Array.isArray(action.payload?.data)
          ? action.payload.data
          : Array.isArray(action.payload)
            ? action.payload
            : [];
        state.subCategoriesError = "";
      })
      .addCase(getSubCategories.rejected, (state, action: any) => {
        state.subCategoriesStatus = "failed";
        state.subCategoriesError =
          action.payload || action.error?.message || "Failed to fetch subcategories";
      })
  }
})

export default productsSlice.reducer
